import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "procedures-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", { class: "io-mfe-ig-dt-col-left-spacer" }, null, -1)
const _hoisted_4 = {
  key: "action",
  class: "io-mfe-ig-dt-col-action"
}
const _hoisted_5 = {
  key: "modifier",
  class: "io-mfe-ig-dt-col-modifier"
}
const _hoisted_6 = {
  key: "code",
  class: "code io-mfe-ig-dt-col-code"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: "description",
  class: "text-ellipsis io-mfe-ig-dt-col-desc"
}
const _hoisted_9 = { class: "ellipsis" }

import {ref} from 'vue';
import { QTableProps } from 'quasar';
import DataTable from 'components/grouper-common/DataTable.vue';
import { useGrouperStore } from 'stores/grouper-store';
import { CodeType } from 'src/contracts/codeType';
import { storeToRefs } from 'pinia';
import { Code } from 'src/contracts/code';
import { vOnClickOutside } from '@vueuse/components';
import { useSearchStore } from 'stores/search-store';

export default /*#__PURE__*/_defineComponent({
  __name: 'ProceduresPane',
  setup(__props) {

const cloneDeep = require('lodash.clonedeep');

const columns: QTableProps['columns'] = [
  {name: 'left-spacer', align: 'center', label: '', field: 'left-spacer', sortable: false},
  {name: 'action', align: 'center', label: '', field: 'action', sortable: false},
  {name: 'modifier', align: 'center', label: 'DRG Modifier', field: 'modifier', sortable: false},
  {name: 'code', align: 'left', label: 'Code', field: 'code', sortable: false},
  {name: 'desc', align: 'left', label: 'Procedure Description', field: 'desc', sortable: false}
]
const searchStore = useSearchStore();
const grouperStore = useGrouperStore();
const { procedureCodes, editsSelectedCode } = storeToRefs(grouperStore);
let currentCode: Code | undefined = undefined;
let currentRow = ref(-1);

function rowClasses(index: number, row: Code): string {
  const classList = [];

  if(row.code === editsSelectedCode.value) {
    classList.push('highlight-row');
  }

  if (editing(index)) {
    classList.push('editing-row');
  } else if (index % 2 === 0) {
    classList.push('iodine-alternate-table-row');
  } else {
    classList.push('bg-white');
    classList.push('text-black');
  }

  return classList.join(' ');
}

function dxReorderd() {
  grouperStore.recalculateNeeded();
}

function titleText() {
    return `Procedures (${procedureCodes.value?.length || 0})`
}

function deleteCode(index: number): void {
  if (currentRow.value !== -1) {
    resetCode(currentRow.value);
  }

  procedureCodes.value?.splice(index, 1);
  currentRow.value = -1;
  grouperStore.recalculateNeeded();
}

function editCode(index: number, editing = true): void {
  // reset previous row before editing new row
  if (currentRow.value != index && currentRow.value > -1) {
    if (currentCode) {
      procedureCodes.value[currentRow.value] = currentCode;
      grouperStore.recalculateNeeded();
    }

  }
  // make a copy of the row for reset
  currentCode = index >= 0 ? cloneDeep(procedureCodes.value[index]) : undefined;
  currentRow.value = editing ? index : -1;
}

function editing(index: number): boolean {
  return currentRow.value === index;
}

function saveCode() {

  if (searching > 0) {
    return;
  }

  const editingCode = procedureCodes.value[currentRow.value];
  if (editingCode.code && editingCode.description) {
    currentRow.value = -1;

    if (editingCode.code != currentCode?.code) {
      grouperStore.recalculateNeeded();
    }
  }
}

function resetCode(index: number): void {
  procedureCodes.value[index] = currentCode || procedureCodes.value[index];
  currentRow.value = -1;
  currentCode = undefined;
}

function outsideClick(index: number) {
  if (currentRow.value == index) {
    resetCode(index);
  }

  editsSelectedCode.value = '';
}
let searching = 0;
async function searchCodes(text: string, index: number) {
  searching++;
  try {
    const code = await searchStore.quickAddCodeSearch(text, CodeType.Procedure);
    if (code) {
      procedureCodes.value[index].description = code.shortDescription || code.mediumDescription;
    } else {
      procedureCodes.value[index].description = '';
    }
  } catch (e) {
    procedureCodes.value[index].description = '';
  } finally {
    searching--;
  }
}


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_input = _resolveComponent("q-input")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DataTable, {
      title: titleText(),
      rows: _unref(procedureCodes),
      "collapse-type": 'icon-based',
      columns: columns,
      type: _unref(CodeType).Procedure,
      onReorder: dxReorderd,
      onDragStart: _cache[2] || (_cache[2] = ($event: any) => (resetCode(_unref(currentRow))))
    }, {
      "dt-thead": _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (col) => {
              return _createElementVNode("th", {
                class: _normalizeClass(["ellipsis", (col.headerClasses ? col.headerClasses : '') + ` io-mfe-ig-dt-col-${col.name}`]),
                key: col.name
              }, _toDisplayString(col.label), 3)
            }), 64))
          ])
        ])
      ]),
      "dt-rows": _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(procedureCodes), (row, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("tr", {
            key: index,
            class: _normalizeClass(rowClasses(index, row)),
            onClick: ($event: any) => (editCode(index))
          }, [
            _hoisted_3,
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_q_btn_dropdown, {
                "no-caps": "",
                dense: "",
                flat: "",
                unelevated: "",
                class: "text-none io-mfe-ig-icon-button-small q-btn--round",
                "dropdown-icon": "fa-solid fa-ellipsis-vertical",
                size: "sm",
                "content-class": "io-mfe-ig-action-menu"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_list, null, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        clickable: "",
                        onClick: ($event: any) => (deleteCode(index))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { side: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                class: "io-mfe-ig-icon-medium",
                                name: "fa-light fa-circle-trash"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Delete Code")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("td", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.drgModifier, (impact, index) => {
                return (_openBlock(), _createBlock(_component_q_chip, {
                  key: index,
                  class: _normalizeClass(impact)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(impact) + " ", 1),
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Operating Room")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]),
            _createElementVNode("td", _hoisted_6, [
              (!editing(index))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(row.code), 1))
                : _createCommentVNode("", true),
              (editing(index))
                ? (_openBlock(), _createBlock(_component_q_input, {
                    key: 1,
                    dense: "",
                    outlined: "",
                    modelValue: row.code,
                    "onUpdate:modelValue": [($event: any) => ((row.code) = $event), ($event: any) => (searchCodes(row.code, index))],
                    modelModifiers: { trim: true },
                    placeholder: "Add Code",
                    autofocus: "",
                    size: "16px",
                    onKeydown: [
                      _cache[0] || (_cache[0] = _withKeys(_withModifiers(($event: any) => (saveCode()), ["prevent"]), ["enter"])),
                      _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (saveCode()), ["prevent"]), ["tab"]))
                    ]
                  }, {
                    append: _withCtx(() => [
                      (row.description === '' && row.code)
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 0,
                            name: "fa-light fa-circle-exclamation",
                            size: "16px"
                          }))
                        : (row.description && row.code)
                          ? (_openBlock(), _createBlock(_component_q_icon, {
                              key: 1,
                              name: "fa-light fa-circle-trash",
                              onClick: ($event: any) => (deleteCode(index)),
                              size: "16px"
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.description), 1)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_9, _toDisplayString(row.description), 1)
            ])
          ], 10, _hoisted_2)), [
            [_unref(vOnClickOutside), () => outsideClick(index)]
          ])
        }), 128))
      ]),
      _: 1
    }, 8, ["title", "rows", "type"])
  ]))
}
}

})